/* eslint-disable */
// This file contains custom GraphQL queries for metal prices

export const getCurrentPrices = /* GraphQL */ `
  query GetCurrentPrices {
    getCurrentPrices {
      current {
        timestamp
        prices {
          platinum {
            price
            date
          }
          palladium {
            price
            date
          }
          rhodium {
            price
            date
          }
        }
      }
    }
  }
`;

export const getHistoricalPrices = /* GraphQL */ `
  query GetHistoricalPrices($hours: Int) {
    getHistoricalPrices(hours: $hours) {
      history {
        timestamp
        prices {
          platinum {
            price
            date
          }
          palladium {
            price
            date
          }
          rhodium {
            price
            date
          }
        }
      }
    }
  }
`; 